export default {
      id: "first-id-usage",
      viewBox: "0 0 40 50",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#first-id",
      toString: function () {
        return this.url;
      }
    }